module.exports = __webpack_public_path__ + "img/banner1_7.d6ba5e71.png";